module.exports = __webpack_public_path__ + "e1e055cd9dc71e52fb4657399519b5ae.svg";